// Money is a JSON number from the API (exact cents; the backend validates and stores 2 decimal places). It is shown with
// formatMoney (providers/salon-intl-provider.tsx), in the salon's currency and locale.

export const toMoneyInput = (amount: number): string => amount.toFixed(2);
